import React from 'react';
import * as C from "../componentsM/index";
import picture from "../assets/screencapture-tis-edu-pk-OrganizationalCharts-2025-02-19-17_16_16.png"

const OrganizationalCharts = () => <>

    <C.Hero title={"ORGANISATIONAL CHARTS"} image={"/hero/8.jpg"} />


    <section className='p-4 md:p-24'>

        


        <figure className='w-full mx-auto'>
            <img className='w-full h-full object-contain' src={picture} alt="" />
        </figure>




    </section>

</>


export default OrganizationalCharts